import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import { EvBookingView, VAMtypes } from "../../_loadingHelpers/VAM";
import _TabEnabledMixin from '../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import FinderBaseV2 from '../../FinderBase/FinderBaseV2';

class EvBookingOverviewFinder extends compose(FinderBaseV2, _TabEnabledMixin) {
    //templateString = template;

    private bookingFormatter(cell: StaticTable.StaticTableCell<VAMtypes.EvBookingEditorEntity>): boolean {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {
            
            default:
                return false;
        }
    }

    private openDetailView(row: StaticTable.StaticTableRow<VAMtypes.EvBookingEditorEntity>, rowGroup: StaticTable.StaticTableRowGroup<VAMtypes.EvBookingEditorEntity>) {

        let entity = rowGroup.entity;

        let editor = new EvBookingView();
        editor.setup(entity.ID, entity.ev_booking_name);
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinderWithCallfunctions(
            "Webtool_API_EvBookingOverviewFinder_GetFilterOptionsJSON",
            "Webtool_API_EvBookingOverviewFinder_GetEventsJSON",
            lang.hitch(this, this.openDetailView),
            lang.hitch(this, this.bookingFormatter)
        );
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvBookingOverviewFinder);